import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { NavItem, NavItemDropdown } from 'libs/shared-lib/interfaces/partner-web/navigation';

@Pipe({
    name: 'isNavDropdown',
    standalone: true,
})
export class IsNavDropdown implements PipeTransform {
    transform(navItem: NavItem | NavItemDropdown): navItem is NavItemDropdown {
        return (navItem as NavItemDropdown).items !== undefined;
    }
}
